import { BellIcon } from '../../icons/navigation/bell-icon'
import { DocumentIcon } from '../../icons/navigation/document-icon'
import { HouseIcon } from '../../icons/navigation/house-icon'
import { PeopleIcon } from '../../icons/navigation/people-icon'
import { PlusIcon } from '../../icons/navigation/plus-icon'
import { BellFilled } from '../../icons/sidebar/bell-filled'
import { Briefcase } from '../../icons/sidebar/briefcase'
import { BriefcaseFilled } from '../../icons/sidebar/briefcase-filled'
import { ChatFilled } from '../../icons/sidebar/chat-filled'
import { ChatIcon } from '../../icons/sidebar/chat-icon'
import { HouseFilled } from '../../icons/sidebar/house-filled'
import { SearchIcon } from '../../icons/sidebar/search-icon'

const iconMap = {
  bell: BellIcon,
  house: HouseIcon,
  people: PeopleIcon,
  plus: PlusIcon,
  document: DocumentIcon,
  briefcase: Briefcase,
  briefcaseFilled: BriefcaseFilled,
  houseFilled: HouseFilled,
  chat: ChatIcon,
  chatFilled: ChatFilled,
  bellFilled: BellFilled,
  search: SearchIcon,
}

export type IconName = keyof typeof iconMap

interface TabButtonIconProps {
  name: IconName
  className?: string
}

export default function TabButtonIcon({ name, className }: TabButtonIconProps) {
  const Icon = iconMap[name]

  return <Icon className={className} />
}
